export interface ReviewOpsCodexModelDefinition {
    value: string;
    model: string;
    label: string;
    reasoning: string[];
}

export const REVIEWOPS_CODEX_ALLOWED_REASONING_EFFORTS: string[] = ['low', 'medium', 'high', 'xhigh', 'max', 'ultra'];

export const REVIEWOPS_CODEX_BUILTIN_MODEL_DEFINITIONS: ReviewOpsCodexModelDefinition[] = [
    { value: 'gpt-6.1-sol', model: 'gpt-6.1-sol', label: '6.1 sol', reasoning: ['low', 'medium', 'high', 'xhigh', 'max', 'ultra'] },
    { value: 'gpt-6-astra', model: 'gpt-6-astra', label: '6 astra', reasoning: ['low', 'medium', 'high', 'xhigh', 'max', 'ultra'] },
    { value: 'gpt-6-sol', model: 'gpt-6-sol', label: '6 sol', reasoning: ['low', 'medium', 'high', 'xhigh', 'max', 'ultra'] },
    { value: 'gpt-6-luna', model: 'gpt-6-luna', label: '6 luna', reasoning: ['low', 'medium', 'high', 'xhigh', 'max'] },
    { value: 'gpt-5.6-sol', model: 'gpt-5.6-sol', label: '5.6 sol', reasoning: ['low', 'medium', 'high', 'xhigh', 'max', 'ultra'] },
    { value: 'gpt-5.6-terra', model: 'gpt-5.6-terra', label: '5.6 terra', reasoning: ['low', 'medium', 'high', 'xhigh', 'max', 'ultra'] },
    { value: 'gpt-5.6-luna', model: 'gpt-5.6-luna', label: '5.6 luna', reasoning: ['low', 'medium', 'high', 'xhigh', 'max'] },
    { value: 'gpt-5.5', model: 'gpt-5.5', label: '5.5', reasoning: ['low', 'medium', 'high', 'xhigh'] }
];

export function reviewOpsCodexBuiltinModelDefinitions(): ReviewOpsCodexModelDefinition[] {
    return REVIEWOPS_CODEX_BUILTIN_MODEL_DEFINITIONS.map((item: ReviewOpsCodexModelDefinition) => ({
        value: item.value,
        model: item.model,
        label: item.label,
        reasoning: item.reasoning.slice()
    }));
}

export function reviewOpsCodexBuiltinModelSettings(): any[] {
    return reviewOpsCodexBuiltinModelDefinitions().map((item: ReviewOpsCodexModelDefinition) => ({
        value: item.value,
        provider: 'openai',
        model: item.model,
        label: item.label,
        context_window: 0,
        auto_compact_token_limit: 0
    }));
}

export function reviewOpsCodexBuiltinModelOptionRows(): any[] {
    return reviewOpsCodexBuiltinModelDefinitions().map((item: ReviewOpsCodexModelDefinition) => ({
        value: item.value,
        provider: 'openai',
        model: item.model,
        label: item.label,
        reasoning: item.reasoning.slice(),
        context_window: 0,
        auto_compact_token_limit: 0,
        runtime_key: `openai:${item.value}`
    }));
}

export function reviewOpsCodexReasoningSelectOptions(reasoning: string[]): any[] {
    return (Array.isArray(reasoning) ? reasoning : [])
        .map((effort: string) => String(effort || '').trim().toLowerCase())
        .filter((effort: string, index: number, rows: string[]) => {
            return REVIEWOPS_CODEX_ALLOWED_REASONING_EFFORTS.includes(effort) && rows.indexOf(effort) === index;
        })
        .map((effort: string) => ({ value: effort, label: effort }));
}

export function reviewOpsCodexModelAliases(): any {
    return {
        '5.5': 'gpt-5.5',
        'gpt-5.5': 'gpt-5.5',
        '5.6 sol': 'gpt-5.6-sol',
        '5.6-sol': 'gpt-5.6-sol',
        'gpt-5.6 sol': 'gpt-5.6-sol',
        'gpt-5.6-sol': 'gpt-5.6-sol',
        '5.6 terra': 'gpt-5.6-terra',
        '5.6-terra': 'gpt-5.6-terra',
        'gpt-5.6 terra': 'gpt-5.6-terra',
        'gpt-5.6-terra': 'gpt-5.6-terra',
        '5.6 luna': 'gpt-5.6-luna',
        '5.6-luna': 'gpt-5.6-luna',
        'gpt-5.6 luna': 'gpt-5.6-luna',
        'gpt-5.6-luna': 'gpt-5.6-luna',
        '6.1 sol': 'gpt-6.1-sol',
        '6.1-sol': 'gpt-6.1-sol',
        'gpt 6.1 sol': 'gpt-6.1-sol',
        'gpt-6.1 sol': 'gpt-6.1-sol',
        'gpt-6.1-sol': 'gpt-6.1-sol',
        '6 astra': 'gpt-6-astra',
        '6-astra': 'gpt-6-astra',
        'gpt 6 astra': 'gpt-6-astra',
        'gpt-6 astra': 'gpt-6-astra',
        'gpt-6-astra': 'gpt-6-astra',
        '6 sol': 'gpt-6-sol',
        '6-sol': 'gpt-6-sol',
        'gpt 6 sol': 'gpt-6-sol',
        'gpt-6 sol': 'gpt-6-sol',
        'gpt-6-sol': 'gpt-6-sol',
        '6 luna': 'gpt-6-luna',
        '6-luna': 'gpt-6-luna',
        'gpt 6 luna': 'gpt-6-luna',
        'gpt-6 luna': 'gpt-6-luna',
        'gpt-6-luna': 'gpt-6-luna'
    };
}
